import http from '@/communication/AuthConnection'

/**
* Read the file dropped
*/
const readFile = (eventId, pFile) => {
  const formData = new FormData()
  formData.append('eventId', eventId)
  formData.append('fileCSV', pFile)
  return http
    .post('/v1/event/upload-items', formData, {
      headers: {
        'Content-type': 'multipart/form-data'
      }
    })
}

export default readFile



// WEBPACK FOOTER //
// ./src/view/event/components/edit-event/form-file-input/FileHandle.js